// Constantes para Estações Meteorológicas

export const stationsPerCity = [
  {
    title: 'Estações localizadas em Rolante/RS',
    stations: [
      {
        title: 'Alto Rolante',
        url: 'https://resources.cemaden.gov.br/graficos/interativo/grafico_CEMADEN.php?idpcd=17798&uf=RS',
        image: ['/images/estacoes/alto_rolante.jpeg'],
      },
      {
        title: 'Bairro Contestado',
        url: 'https://resources.cemaden.gov.br/graficos/interativo/grafico_CEMADEN.php?idpcd=17799&uf=RS',
        image: ['/images/estacoes/bairro_contestado.jpeg'],
      },
      {
        title: 'Bairro Rio Branco',
        url: 'https://resources.cemaden.gov.br/graficos/interativo/grafico_CEMADEN.php?idpcd=17797&uf=RS',
        image: ['/images/estacoes/bairro_rio_branco.jpeg'],
      },
      {
        title: 'IFRS Campus Rolante (INMET)',
        url: 'https://tempo.inmet.gov.br/TabelaEstacoes/B819',
        image: ['/images/estacoes/inmet_rolante.jpeg'],
      },
      {
        title: 'IFRS Campus Rolante (UFRGS)',
        url: 'https://www.weatherlink.com/embeddablePage/show/00e64197e0334853b259b346241fc82e/summary',
        image: ['/images/estacoes/ifrs_campus_rolante.jpg'],
      },
      {
        title: 'Ilha Nova',
        url: 'https://www.weatherlink.com/embeddablePage/show/6edfead3c89544c09a2b6783be748098/summary',
        image: ['/images/estacoes/ilha_nova.jpeg'],
      },
      {
        title: 'Maragato',
        url: 'https://www.weatherlink.com/embeddablePage/show/76ba99b539874c09b34c87c0e45402f5/summary',
        image: ['/images/estacoes/maragato.jpeg'],
      },
      {
        title: 'Mascarada',
        url: 'https://redehidrometeorologica.defesacivil.rs.gov.br/Estacao/DCRS-00005',
        image: ['/images/estacoes/mascarada.jpeg'],
      },
      {
        title: 'Mata Olho',
        url: 'https://www.wunderground.com/dashboard/pws/IROLAN15',
        image: ['/images/estacoes/mata_olho.jpeg'],
      },
      {
        title: 'Morro Grande',
        url: 'https://www.weatherlink.com/embeddablePage/show/bfa57af5194140449306a261ef4a0e2e/summary',
        image: ['/images/estacoes/morro_grande.jpg'],
      },
      {
        title: 'Rolantinho',
        url: 'https://redehidrometeorologica.defesacivil.rs.gov.br/Estacao/DCRS-00006',
        image: ['/images/estacoes/rolantinho.jpeg'],
      },
    ],
  },
  {
    title: 'Estações localizadas em Riozinho/RS',
    stations: [
      {
        title: 'Centro',
        url: 'https://resources.cemaden.gov.br/graficos/interativo/grafico_CEMADEN.php?idpcd=7365&uf=RS',
        image: ['/images/estacoes/centro-riozinho.jpeg'],
      },

      {
        title: 'Chuvisqueiro',
        url: 'https://www.weatherlink.com/embeddablePage/show/20a27a673a6b440d984665dc390a0564/summary',
        image: ['/images/estacoes/chuvisqueiro.jpeg'],
      },
      {
        title: 'Corpo de Bombeiros Voluntários',
        url: 'https://www.weatherlink.com/embeddablePage/show/ff3f9edccbd445398e84fa95863d9b27/summary',
        image: ['/images/estacoes/bombeiros_voluntarios.jpeg'],
      },
    ],
  },
  {
    title: 'Estações localizadas em São Francisco de Paula/RS',
    stations: [
      {
        title: 'Centro',
        image: ['/images/estacoes/sao_chico_samu.jpg'],
        url: 'https://resources.cemaden.gov.br/graficos/interativo/grafico_CEMADEN.php?idpcd=7660&uf=RS',
      },
      {
        title: 'Parque Natural Municipal da Ronda',
        image: ['/images/estacoes/inmet_sao_francisco_de_paula.jpeg'],
        url: 'https://tempo.inmet.gov.br/TabelaEstacoes/B820',
      },
      {
        title: 'Rincão dos Kroeff',
        image: ['/images/estacoes/rincao_dos_kroeff.jpeg'],
        url: 'https://www.weatherlink.com/embeddablePage/show/2eb10f2c32d04e1ab2aa85f6422b9512/summary',
      },
      {
        title: 'Sítio Água da Rainha',
        image: ['/images/estacoes/sitio_agua_da_rainha.jpg'],
        url: 'https://www.weatherlink.com/embeddablePage/show/31994ddcdd464d40927fc554a61f71e3/summary',
      },
    ],
  },
  {
    title: 'Mapa de localização das estações',
    stations: [
      {
        title:
          'Localização geográfica e acesso ao histórico de dados das estações meteorológicas.',
        image: ['/images/estacoes/mapa_estacoes.jpg'],
        url: 'https://www.google.com/maps/d/u/1/edit?mid=1YuQ2l0x6gt2_9jRVmBOpp21aiFUmx-8&usp=sharing',
      },
    ],
  },
];
